import { BooleanInput, Create, CreateContextProvider, Edit, EditContextProvider, Form, required, SaveButton, SelectInput, TextInput, Toolbar, TopToolbar, useCreateController, useEditController, useNotify, useRedirect, useRefresh, useTranslate } from 'react-admin';
import { Box, Card, Divider, Stack, Typography, Button as MUIButton, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Resources } from '../../resource';
import AdminConfigForm from './AdminConfigForm';
import { PermissionButton } from 'src/routes/components/permission-button';

const EditAdminConfig = ({ id, onClose }: { id: string | number; onClose: () => void }) => {
    const notify = useNotify();
    const t = useTranslate();
    const refresh = useRefresh();

    const controller = useEditController({
        id,
        resource: Resources.adminConfig,
        mutationMode: 'pessimistic',
        mutationOptions: {
            onSuccess: () => {
                notify(t('module.adminConfig.updateSuccess'), { type: 'success' });
                refresh()
                onClose()
            },
            onError: (error: any) => {
                const errorCode = error?.body?.code || error?.code;
                switch (errorCode) {
                    case 'ADMIN_CONFIG_CONFLICT':
                        notify(t('module.adminConfig.validate.conflict'), { type: 'error' });
                        break;
                    case 'ADMIN_CONFIG_INVALID_OBJECT':
                        notify(t('module.adminConfig.validate.invalidObject'), { type: 'error' });
                        break;
                    default:
                        notify(t('module.adminConfig.unknownErrorUpdate'), { type: 'error' });
                        break;
                }
            },
        },
    });
    
    if (controller.isLoading || !controller.record) return null;

    return (
        <EditContextProvider value={controller}>
            <Form disableInvalidFormNotification>
                <DialogTitle>{t('module.adminConfig.edit')}</DialogTitle>
                <DialogContent>
                    <AdminConfigForm isCreate={false} />
                </DialogContent>
                <DialogActions>
                    <MUIButton
                        variant="outlined"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {t('actions.cancel')}
                    </MUIButton>
                    <PermissionButton resource="admin-configs" action="update">
                        <SaveButton />
                    </PermissionButton>
                </DialogActions>
            </Form>
        </EditContextProvider>
    );
};

export default EditAdminConfig;
